import React from 'react';
import Translation from '../../../../translation/translation';

function EmptyLabel() {
    return <Translation
        className="statusbar-mobile-current-status__postcode-label"
        translationKey="catalog-statusbar-mobile-empty-postcode-label"
    />;
}

export { EmptyLabel};
